import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'socialMediaDataToShow',
})
export class SocialMediaDataToShowPipe implements PipeTransform {
  transform(socialLinkData: any[], firstLinkNumberToShow: number): any[] {
    if (!socialLinkData) {
      return [];
    }

    if (!firstLinkNumberToShow) {
      return socialLinkData;
    }

    return socialLinkData.slice(firstLinkNumberToShow);
  }
}
